/*
 * if you want to add accordion behaviour just add data-accordion-mode=true to the sliders container
 */
import $ from 'jquery';
import * as config from '../core/config';

const SectionSlider = function() {
  'use strict';

  var slideSpeed = config.getInt('sliders.slideSpeed');

  this.self = {
    init: function() {
      $('body').on('click', '.section-opener', this.onClick);
    },
    onClick: function(event) {
      event.preventDefault();

      var $currentTarget = $(event.currentTarget);
      var $header = $currentTarget.closest('.section-slider');
      var bOpened = $header.is('.active');
      var $slideSection = $header.find('.section-content').first();
      var speed = slideSpeed;
      var headerSlideSpeed = $header.data('slideSpeed');

      if (headerSlideSpeed) {
        speed = parseInt(headerSlideSpeed, 10);
      }

      if ($(event.target).is('select, option')) {
        return;
      }

      if (bOpened) {
        $slideSection.slideUp(speed);
        $header.removeClass('active');
      } else {
        $currentTarget
          .closest('[data-accordion-mode=true]')
          .find('.active')
          .each(function(i, val) {
            $(val)
              .removeClass('active')
              .find('.section-content')
              .slideUp(speed);
          });
        $slideSection.slideDown(speed);
        $header.addClass('active');
      }
    }
  };

  this.self.init();
};

new SectionSlider();



/** WEBPACK FOOTER **
 ** ./legacy/home24/helpers/section-slider.js
 **/